import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { requestCompletenessStatusForFinSobSidePanelItem } from 'partner360/features/finSobSidePanel/api/requestCompletenessStatusForFinSobSidePanelItem'
import {
  changeFinSobItem,
  selectFinSobItem,
} from 'partner360/features/finSobSidePanel/finSobSidePanelSlice'
import { useChangeNotApplicable } from 'partner360/hooks/finSob/useChangeNotApplicable'
import { FinSobSidePanelSettingStatus } from 'partner360/models/finSobSidePanel/FinSobSidePanelSettingStatus'
import { IFinSobSidePanelSetting } from 'partner360/models/finSobSidePanel/IFinSobSidePanelSetting'

interface IUseNotApplicable {
  changeLoading: (isLoading: boolean) => void
  programType: ProgramTypes
  partnerId: string
  fYear: number
}

export const useNotApplicable = ({
  changeLoading,
  programType,
  partnerId,
  fYear,
}: IUseNotApplicable) => {
  const dispatch = useAppDispatch()

  const onChangeNotApplicable = useChangeNotApplicable({
    partnerId,
    fYear,
  })

  const changeNotApplicable = useCallback(
    async (item: IFinSobSidePanelSetting, isNeedDropCommitment?: boolean) => {
      changeLoading(true)
      const newIsApplicableValue = item.IsApplicable ? 0 : 1
      const updatedItem = {
        ...item,
        IsApplicable: newIsApplicableValue,
        Status: newIsApplicableValue ? FinSobSidePanelSettingStatus.NotCompleted : item.Status,
      }

      dispatch(selectFinSobItem({ item: updatedItem, programType }))
      dispatch(changeFinSobItem({ item: updatedItem, programType }))

      await onChangeNotApplicable({
        isNotApplicable: updatedItem.IsApplicable ? 0 : 1,
        categoryField: updatedItem.Title,
        isNeedDropCommitment,
      })
      await dispatch(
        requestCompletenessStatusForFinSobSidePanelItem({
          partnerId,
          fYear,
          programType,
          category: item.Title,
        })
      ).unwrap()
      changeLoading(false)
    },
    [changeLoading, dispatch, fYear, onChangeNotApplicable, partnerId, programType]
  )

  const onChangeNotApplicableFlag = useCallback(
    async (item: IFinSobSidePanelSetting, isNeedDropCommitment?: boolean) => {
      dispatch(selectFinSobItem({ item: item, programType }))
      await changeNotApplicable(item, isNeedDropCommitment)
    },
    [changeNotApplicable, dispatch, programType]
  )

  return { onChangeNotApplicableFlag }
}
